import { FormattedMessage } from 'react-intl';

import { StatusBanner, StatusBannerAutoHide } from '@xing-com/banner';

import { useSearchAndShuffleContext } from './context';
import { Decks } from './decks';
import { Header } from './header';
import { InlineAd } from './inline-ad';
import { SavedCards } from './saved-cards';
import { Container, Link } from './search-and-shuffle.styled';
import type { HookData, HookSavedData } from './types';
import { useDealer } from './use-dealer';
import { useSavedCards } from './use-saved-cards';

type SearchAndShuffleProps = {
  useData: HookData;
  useSavedData: HookSavedData;
  hideSavedCards?: boolean;
  hideAds?: boolean;
};

export const SearchAndShuffle: React.FC<SearchAndShuffleProps> = ({
  useData,
  useSavedData,
  hideSavedCards,
  hideAds,
}) => {
  const { statusBanner, setStatusBanner } = useSearchAndShuffleContext();
  const { reshuffle } = useDealer({ useData });
  useSavedCards({ useSavedData });

  const handleBannerClose = (): void => {
    setStatusBanner((prev) => ({ ...prev, show: false }));
  };
  const StatusBannerComponent =
    statusBanner?.autohide === false ? StatusBanner : StatusBannerAutoHide;

  return (
    <>
      <Container>
        <Header reshuffle={reshuffle} />
        <Decks />
        {hideSavedCards ? null : <SavedCards />}
        {hideAds ? null : <InlineAd />}
      </Container>
      <StatusBannerComponent
        variant={statusBanner?.type}
        show={statusBanner?.show}
        handleOnClose={handleBannerClose}
        timeout={statusBanner?.type === 'error' ? 5000 : 3000}
      >
        {statusBanner?.key ? (
          <FormattedMessage
            id={statusBanner.key}
            values={{
              b: (chunks: React.ReactNode) => <b>{chunks}</b>,
              login: (
                <Link
                  href="http://login.xing.com/?dest_url=https://www.xing.com/jobs/dream?id=4795388841371516423.35764a"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FormattedMessage id="SEARCH_AND_SHUFFLE_STATUS_BANNER_LIKE_LOGGED_OUT_LINK" />
                </Link>
              ),
            }}
          />
        ) : null}
      </StatusBannerComponent>
    </>
  );
};
